import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ErrorsHttpService } from '@qaroni-core/services/commons/errors-http/errors-http.service';
import { TempFiles } from '@qaroni-core/types/files/temp-files';
import { TempFilesApiObject } from '@qaroni-core/types/files/temp-files.response';
import { Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { TempFileSnackbarsService } from './temp-file-snackbars.service';
import { TempFilesHttpService } from './temp-files-http.service';

@Injectable({
  providedIn: 'root',
})
export class TempFilesService {
  private uploadFileSubject = new Subject<TempFiles | null>();

  private http = inject(TempFilesHttpService);
  private snackbars = inject(TempFileSnackbarsService);
  private errorsHttp = inject(ErrorsHttpService);

  public getUploadFileSubject$() {
    return this.uploadFileSubject.asObservable().pipe(shareReplay(1));
  }

  public uploadTempFile(file: FormData) {
    this.http.uploadTempFile$(file).subscribe({
      next: this.nextUploadTempFile,
      error: this.errorUploadTempFile,
    });
  }

  private nextUploadTempFile = (response: TempFilesApiObject) => {
    if (!response.result[0]) {
      this.snackbars.failedUploadFile();
      this.uploadFileSubject.next(null);
      return;
    }
    this.uploadFileSubject.next(response.result[0]);
  };

  private errorUploadTempFile = (error: HttpErrorResponse) => {
    if (this.errorsHttp.isControlledError(error, 'E0004')) {
      this.snackbars.notAllowedFileType();
    } else {
      this.snackbars.failedUploadFile();
    }
    this.uploadFileSubject.next(null);
  };
}
